import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
            <i className="ri-arrow-left-line text-lg"></i>
            <span className="text-sm font-medium">トップページへ戻る</span>
          </Link>
          <div className="w-32 h-8 flex items-center justify-center">
            <img
              src="https://static.readdy.ai/image/9700cfc123ce22cf391e77d50f0f2b6c/16042ced149becdaff7cadb9beefd742.png"
              alt="株式会社万燈"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <div className="bg-white rounded-lg p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            プライバシーポリシー
          </h1>
          <p className="text-gray-500 text-sm mb-10 pb-8 border-b border-gray-100">
            最終更新日：2024年1月1日
          </p>

          <div className="space-y-10 text-gray-700 leading-relaxed">

            {/* 前文 */}
            <section>
              <p className="text-base">
                株式会社ON TRUST（以下「当社」といいます）は、お客様の個人情報の保護を重要な責務と認識し、個人情報の保護に関する法律（個人情報保護法）その他の関連法令を遵守するとともに、以下のプライバシーポリシー（以下「本ポリシー」といいます）に従い、個人情報を適切に取り扱います。
              </p>
            </section>

            {/* 第1条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">1</span>
                個人情報の定義
              </h2>
              <p className="text-base pl-11">
                本ポリシーにおいて「個人情報」とは、個人情報保護法第2条第1項に定める個人情報、すなわち生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む）をいいます。
              </p>
            </section>

            {/* 第2条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">2</span>
                収集する個人情報の種類
              </h2>
              <p className="text-base pl-11 mb-4">当社は、以下の個人情報を収集することがあります。</p>
              <ul className="pl-11 space-y-2">
                {[
                  '氏名（フルネーム・ふりがな）',
                  'メールアドレス',
                  '電話番号',
                  '住所・居住地域',
                  '年齢・生年月日',
                  '職業・勤務先情報',
                  '年収・資産状況などの財務情報',
                  'お問い合わせ・ご相談内容',
                  'ウェブサイトの閲覧履歴・アクセスログ（Cookie等を含む）',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-base">
                    <span className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2 flex-shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </section>

            {/* 第3条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">3</span>
                個人情報の収集方法
              </h2>
              <p className="text-base pl-11 mb-4">当社は、以下の方法により個人情報を収集します。</p>
              <ul className="pl-11 space-y-2">
                {[
                  'ウェブサイト上のお問い合わせフォーム・申込フォームへの入力',
                  '個別面談・セミナー等へのお申し込み',
                  'メール・電話・対面でのご相談',
                  'Cookie・アクセス解析ツール（Google Analytics、Metaピクセル等）による自動収集',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-base">
                    <span className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2 flex-shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </section>

            {/* 第4条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">4</span>
                個人情報の利用目的
              </h2>
              <p className="text-base pl-11 mb-4">当社は、収集した個人情報を以下の目的のために利用します。</p>
              <ul className="pl-11 space-y-2">
                {[
                  '個別面談・セミナー等のご予約・ご案内',
                  'サービスに関するお問い合わせへの対応',
                  '住宅費削減に関するご提案・コンサルティングサービスの提供',
                  '当社サービスに関する情報・資料のご提供',
                  'メールマガジン・ニュースレターの配信（ご同意いただいた場合）',
                  'サービス改善・新サービス開発のための統計・分析',
                  '法令に基づく対応',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-base">
                    <span className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2 flex-shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </section>

            {/* 第5条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">5</span>
                個人情報の第三者提供
              </h2>
              <p className="text-base pl-11 mb-4">
                当社は、以下の場合を除き、お客様の個人情報を第三者に提供・開示しません。
              </p>
              <ul className="pl-11 space-y-2">
                {[
                  'お客様ご本人の同意がある場合',
                  '法令に基づき開示が必要な場合',
                  '人の生命・身体・財産の保護のために必要であり、本人の同意を得ることが困難な場合',
                  '国の機関・地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合',
                  '業務委託先（個人情報の取り扱いについて適切な管理を行う者に限る）に対して業務遂行上必要な範囲で提供する場合',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-base">
                    <span className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2 flex-shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </section>

            {/* 第6条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">6</span>
                Cookieおよびトラッキングツールについて
              </h2>
              <div className="pl-11 space-y-4 text-base">
                <p>
                  当社のウェブサイトでは、サービス向上および広告効果測定のため、以下のツールを使用しています。
                </p>
                <div className="bg-gray-50 rounded-lg p-5 space-y-3">
                  <div>
                    <p className="font-semibold text-gray-900 mb-1">Google Analytics</p>
                    <p className="text-gray-600 text-sm">ウェブサイトのアクセス状況を分析するために使用します。収集されたデータはGoogleのプライバシーポリシーに従って管理されます。</p>
                  </div>
                  <div className="border-t border-gray-200 pt-3">
                    <p className="font-semibold text-gray-900 mb-1">Metaピクセル（Facebook Pixel）</p>
                    <p className="text-gray-600 text-sm">Meta（Facebook・Instagram）広告の効果測定および最適化のために使用します。収集されたデータはMetaのデータポリシーに従って管理されます。</p>
                  </div>
                </div>
                <p>
                  ブラウザの設定によりCookieを無効にすることができますが、一部のサービスが正常に機能しない場合があります。
                </p>
              </div>
            </section>

            {/* 第7条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">7</span>
                個人情報の安全管理
              </h2>
              <p className="text-base pl-11">
                当社は、個人情報の漏洩・滅失・毀損の防止その他個人情報の安全管理のために必要かつ適切な措置を講じます。また、個人情報を取り扱う従業員に対して、個人情報の適切な取り扱いについて教育・監督を行います。
              </p>
            </section>

            {/* 第8条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">8</span>
                個人情報の保存期間
              </h2>
              <p className="text-base pl-11">
                当社は、利用目的の達成に必要な期間、個人情報を保存します。利用目的が達成された後は、法令に定める保存義務期間を考慮した上で、速やかに個人情報を削除または匿名化します。
              </p>
            </section>

            {/* 第9条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">9</span>
                個人情報の開示・訂正・削除等のご請求
              </h2>
              <div className="pl-11 space-y-3 text-base">
                <p>
                  お客様は、当社が保有するご自身の個人情報について、以下の権利を有します。
                </p>
                <ul className="space-y-2">
                  {[
                    '開示を求める権利',
                    '内容の訂正・追加・削除を求める権利',
                    '利用の停止・消去を求める権利',
                    '第三者への提供の停止を求める権利',
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2 flex-shrink-0"></span>
                      {item}
                    </li>
                  ))}
                </ul>
                <p>
                  ご請求の際は、下記お問い合わせ窓口までご連絡ください。ご本人確認の上、合理的な期間内に対応いたします。
                </p>
              </div>
            </section>

            {/* 第10条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">10</span>
                プライバシーポリシーの変更
              </h2>
              <p className="text-base pl-11">
                当社は、法令の改正やサービス内容の変更等に伴い、本ポリシーを変更することがあります。変更後のポリシーは、当ウェブサイトに掲載した時点から効力を生じるものとします。重要な変更がある場合は、ウェブサイト上でお知らせします。
              </p>
            </section>

            {/* 第11条 */}
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">11</span>
                お問い合わせ窓口
              </h2>
              <div className="pl-11">
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 space-y-2 text-base">
                  <p className="font-bold text-gray-900 text-lg mb-3">株式会社ON TRUST</p>
                  <div className="flex items-center gap-2 text-gray-700">
                    <i className="ri-global-line text-amber-600"></i>
                    <a
                      href="https://on-trust.co.jp/about_us"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-amber-600 hover:text-amber-700 underline cursor-pointer"
                    >
                      https://on-trust.co.jp/about_us
                    </a>
                  </div>
                  <p className="text-gray-600 text-sm mt-3">
                    個人情報に関するお問い合わせは、上記ウェブサイトのお問い合わせフォームよりご連絡ください。
                  </p>
                </div>
              </div>
            </section>

          </div>

          {/* Back to top */}
          <div className="mt-16 pt-8 border-t border-gray-100 text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white px-8 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-line"></i>
              トップページへ戻る
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-10 mt-8">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-gray-400 text-sm">
            © 2024 株式会社ON TRUST. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
